import { Link, createFileRoute } from "@tanstack/react-router";

import { Button } from "~/components/ui/button";
import { DiscoveryStep } from "~/components/ui/discovery-step";
import { specificGoalsStep } from "~/lib/schemas/coach-discovery";
import { createNoIndexMeta } from "~/lib/shared/meta";

function DiscoveryStepsEntry() {
  return (
    <div className="pb-10">
      <DiscoveryStep.Title title="Start your matching quiz" />
      <DiscoveryStep.SubTitle title="Answer a few quick questions to unlock your personalized coach matches." />
      <DiscoveryStep.Card className="flex flex-col items-center gap-6 text-center">
        <p className="text-base text-gray-600">
          We begin with:{" "}
          <span className="font-semibold">{specificGoalsStep.title}</span>
        </p>
        <div className="flex flex-col gap-3 sm:flex-row">
          <Link to="/discovery/steps/1">
            <Button size="lg" variant="primary" className="px-8">
              Start Step 1
            </Button>
          </Link>
          <Link to="/discovery">
            <Button size="lg" className="px-8">
              Back to discovery overview
            </Button>
          </Link>
        </div>
      </DiscoveryStep.Card>
    </div>
  );
}

export const Route = createFileRoute("/_public/discovery/steps/")({
  head: () =>
    createNoIndexMeta(
      "Start Your Coach Discovery Quiz – Dream Coach Match",
      "Begin the Dream Coach Match discovery quiz to answer quick questions and see tailored coach recommendations.",
    ),
  component: DiscoveryStepsEntry,
});
